import * as yup from "yup";
import {TFunction} from "i18next";
import {CompanyCardField} from "../../../app/api/model/organization/companyCard";
import dayjs from "dayjs";
import {RoadsoftConfigField} from "../../../app/api/model/roadsoft";

export const getOrganizationUpdateValidationSchema = (t: TFunction) =>
    yup.object({
        name: yup.string().required(t("validation_inputRequired")),
        country: yup.string().required(t("validation_inputRequired")),
        locked: yup.string().required(t("validation_inputRequired")),
        productiveStage: yup.string().required(t("validation_inputRequired")),
        lockedReason: yup.string(),
        mainDKVCustomerNumber: yup.object().nullable(),
    });

export const getCreateOrganizationValidationSchema = (t: TFunction) =>
    yup.object({
        name: yup.string().required(t("validation_inputRequired")),
        country: yup.string().required(t("validation_inputRequired")),
        productiveStage: yup.string().required(t("validation_inputRequired")),
        adminLanguage: yup.string().required(t("validation_inputRequired")),
        adminEmail: yup.string().email(t("validation_invalidEmail")).required(t("validation_inputRequired")),
        mainDKVCustomerNumber: yup.object().nullable(),
    });

export const getAddEditCompanyCardValidation = (t: TFunction) =>
    yup.object().shape({
        [CompanyCardField.CARD_ID]: yup
            .string()
            .required(t("validation_inputRequired"))
            .matches(/^[A-Za-z0-9]{16}$/, t("validation_companyCardId")),
        [CompanyCardField.CARD_READER_SLOT]: yup
            .number()
            .integer()
            .min(1, t("validation_cardReaderSlot", {min: 1, max: 120}))
            .max(120, t("validation_cardReaderSlot", {min: 1, max: 120}))
            .required(t("validation_inputRequired")),
        [CompanyCardField.CARD_READER_DRAWER]: yup
            .number()
            .integer()
            .min(1, t("validation_cardReaderDrawer", {min: 1, max: 12}))
            .max(12, t("validation_cardReaderDrawer", {min: 1, max: 12}))
            .required(t("validation_inputRequired")),
        [CompanyCardField.CARD_SERVER_ID]: yup.number().required(t("validation_inputRequired")),
        [CompanyCardField.VALID_UNTIL]: yup
            .date()
            .typeError(t("validation_invalidDate"))
            .required(t("validation_inputRequired"))
            .test(
                "dateIsFuture",
                t("validation_futureDate"),
                (value) => !!value && dayjs(value).unix() >= dayjs(new Date()).startOf("day").unix()
            ),
    });

export const getRoadsoftconfigValidationSchema = (t: TFunction) =>
    yup.object().shape({
        [RoadsoftConfigField.SUBSCRIPTION]: yup.string().required(t("validation_inputRequired")),
    });
